<template lang="pug">
    div.loading(v-if="data==null") Loading ...
    div(v-else)
        div.chartContent(:class="{ showYLabels }")
            span.bar(v-for="[index, entry] of Object.entries(data)")
                span.xLabel(v-if="showXLabels") {{entry.x}}
                span.yLabel(v-if="showYLabels") {{formatYValue(entry.y)}}
                span.bg(:style="{height: (entry.y / maximumValue * 100.0) + '%'}")
</template>

<script>
import { formatBigNumber } from '../utils';
export default {
  props: {
    data: Array,
    showXLabels: {
      type: Boolean,
      default: false
    },
    showYLabels: {
      type: Boolean,
      default: true
    },
    isPercentage: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    maximumValue() {
      if (!this.data) {
        return 1;
      }
      return Math.max(...this.data.map((entry) => entry.y));
    },
  },

  methods: {
    formatYValue(v) {
      if (this.isPercentage) {
        return Math.round(v * 100.0 * 10.0) / 10.0 + "%";
      }

      return formatBigNumber(v);
    }
  }

}
</script>

<style lang="scss" scoped>
$chartColor: rgb(114, 145, 233);

.chartContent {
  height: 15vh;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  position: relative;
  margin-top: 10px;
  grid-gap: 1px;

  > .bar {
    position: relative;
    font-size: 0.7em;
    font-family: Tahoma;

    > .yLabel,
    > .xLabel {
      position: absolute;
      bottom: 2px;
      left: 0;
      z-index: 1;
      color: #444549;
      text-align: center;
      right: 0;
    }

    .yLabel {
      z-index: 999;
      opacity: 0;
      background: #333;
      color: #fff;
      padding: 1px 3px;
      min-width: 35px;
      bottom: unset;
      top: -15px;
      transform: translateX(-50%);
      left: 50%;

      &::after {
        top: 100%;
        left: 50%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: transparent;
        border-top-color: #333;
        border-width: 4px;
        margin-left: -4px;
      }
    }

    &:hover {
      .bg {
        background: lighten($chartColor, 10);
      }
      .yLabel {
        opacity: 1;
      }
    }

    > .xLabel {
      bottom: unset;
      bottom: -20px;
    }

    > .bg {
      background: $chartColor;
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 0;
      min-height: 2px;
    }
  }
}
</style>
